export default __webpack_public_path__ + "24c3cd0ead36c5988133c8859b46a7ee.svg";